import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";


export const fetchAddProvidersLicenseTypes = createAsyncThunk(
    "fetchAddProvidersLicenseTypes",
    async (state) => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/license-types?state=${state || "all"}`);
        return result;
    }
)


export const fetchAddProvidersCertifiedSpecialty = createAsyncThunk(
    "fetchAddProvidersCertifiedSpecialty",
    async () => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/specialties`);
        return result;
    }
)


export const addProvidersDetailsAPI = createAsyncThunk(
    "addProvidersDetailsAPI",
    async (payload) => {
        const result = await FetchRequestHandler("post", `${baseUrl}api/providers`, payload);
        return result;
    }
)
